<nav aria-label="Page navigation example">
    <ul class="pagination justify-content-center">
        <li class="page-item"><a (click)="disminuirPagina()" class="page-link clickable">Previous</a></li>
        <li [ngClass]="activarPagina(pagina)" *ngFor="let pagina of paginas" (click)="consultar(pagina);"><a class="page-link">{{pagina}}</a></li>
        <li class="page-item"><a class="page-link clickable" (click)="aumentarPagina()">Next</a>
        <li *ngIf="mostrarTodo" class="page-item"><a class="page-link clickable" (click)="ocultarPaginador()">Todo</a></li>
    </ul>
</nav>